import { css } from '@emotion/css'
import React from 'react'
import { default as JSZip } from 'jszip'
import NewDownloadIcon from '../components/icons/newDownload'
import NewCopyIcon from '../components/icons/newCopy'
import { copyToClipboard } from './copyToClipboard'
import { Checkmark } from '../components/ImageContainer/icons/Checkmark'
import { CheckmarkBackgroundIcon } from '@paypalcorp/pp-react'

const STYLES_TOP_CONTAINER = css`
  display: flex;
  flex-directin: row;
  justify-content: space-between;
`

const STYLES_TAB_CONTAINER = css`
  border-radius: 6px;
`
const STYLES_TAB_CONTENT = css``

const STYLES_TAB_LIST = css`
  padding-left: 0;
`

const STYLES_TAB_LIST_ITEM = css`
  display: inline-block;
  background: white;
  position: relative;
  border-radius: 6px;
  list-style: none;
  margin-bottom: -1px;
  margin-right: 12px !important;
  padding: 10px 15px;
  font-family: 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  :hover {
    cursor: pointer;
  }
  font-family: 'PayPal Sans Big', 'Helvetica Neue', Arial, sans-serif;
  font-weight: 500;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
`

const STYLES_TAB_LIST_ACTIVE = css`
  background-color: white;
  background: #001c64;
  color: white;
  border-radius: 6px;
`

const TabButton = ({ activeTab, label, onClick, fptiData }) => {
  const handleClick = () => {
    onClick(label)
    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          link: `tab-click:${activeTab.replace('/', '_').toLowerCase()}`,
          component: 'devdiscoverynodeweb',
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(options)
      }
    }
  }

  const classNames = [STYLES_TAB_LIST_ITEM]
  if (activeTab === label) {
    classNames.push(STYLES_TAB_LIST_ACTIVE)
  }

  return (
    <li className={classNames.join(' ')} onClick={handleClick}>
      {label}
    </li>
  )
}

/**
 * Dummy emelent, needed for `<Tabs/>` component to work properly
 */
export const NewCodeTab = ({ children }) => children

export const NewCodeTabs = ({ children }) => {
  const tabs = React.useMemo(
    () => (Array.isArray(children) ? children : [children]),
    [children],
  )
  const [activeTab, setActiveTab] = React.useState(tabs[0].props.label)
  const [isCopied, setIsCopied] = React.useState(false)
  const [isDownloaded, setIsDownloaded] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const fptiData = typeof window !== `undefined` && window.fpti
  const gaData = typeof window !== `undefined` && window.ga
  const beerRef = React.createRef()

  const handleDownload = () => {
    setIsDownloaded(true)
    const zip = new JSZip()

    tabs.forEach((child) => {
      const fileData = child.props.children.props.children
      const blob = new Blob([fileData], { type: 'text/plain' })
      const [folder, file] = child.props.label.split('/')
      if (!file) {
        zip.file(folder.toLowerCase(), blob)
      } else {
        zip.folder(folder).file(file.toLowerCase(), blob)
      }
    })
    zip.generateAsync({ type: 'blob' }).then(function (content) {
      const url = URL.createObjectURL(content)
      const link = document.createElement('a')
      link.download = 'code.zip'
      link.href = url
      link.click()
    })
    setTimeout(() => {
      setIsDownloaded(false)
    }, 2000)
    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          link: `download-content-${activeTab.replace('/', '_').toLowerCase()}`,
          component: 'devdiscoverynodeweb',
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(options)
      }
    }

    if (gaData) {
      gaData('send', 'event', {
        eventCategory: 'codeblock',
        eventAction: 'click',
        eventLabel: `downloadContent-${activeTab
          .replace('/', '_')
          .toLowerCase()}`,
      })
    }
  }
  const handleCopyClipboard = () => {
    setLoading(true)

    tabs.map((child) => {
      if (child.props.label === activeTab) {
        copyToClipboard(child.props.children.props.children)
      }
    })

    setTimeout(() => {
      setLoading(false)
      setIsCopied(true)
    }, 2000)

    setTimeout(() => {
      setIsCopied(false)
    }, 4000)

    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          link: `copy-content-${activeTab.replace('/', '_').toLowerCase()}`,
          component: 'devdiscoverynodeweb',
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(options)
      }
    }

    if (gaData) {
      gaData('send', 'event', {
        eventCategory: 'codeblock',
        eventAction: 'click',
        eventLabel: `copyContent-${activeTab.replace('/', '_').toLowerCase()}`,
      })
    }
  }
  return (
    <>
      <div className={STYLES_TAB_CONTAINER + ' darkTabs-container'}>
        <div className={STYLES_TOP_CONTAINER}>
          <ol className={STYLES_TAB_LIST}>
            {tabs.map((child) => {
              const { label } = child.props
              return (
                <TabButton
                  activeTab={activeTab}
                  key={label}
                  label={label}
                  fptiData={fptiData}
                  onClick={setActiveTab}
                />
              )
            })}
          </ol>
          <div
            style={{
              width: '120px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <div onClick={() => handleCopyClipboard()}>
              {loading && <div className="loader" />}
              {isCopied && (
                <CheckmarkBackgroundIcon
                  size="lg"
                  className="checkmark-bg-icon"
                  color="sysColorAccent3Main"
                />
              )}
              {!loading && !isCopied && <NewCopyIcon />}
            </div>
            {tabs.length > 1 && (
              <div onClick={() => handleDownload()}>
                {isDownloaded ? (
                  <>
                    <div className="imageContainerBtn imageContainerBtnSuccess">
                      <Checkmark />
                    </div>
                  </>
                ) : (
                  <NewDownloadIcon />
                )}
              </div>
            )}
          </div>
        </div>
        <div className={STYLES_TAB_CONTENT}>
          {tabs.map((child) => {
            if (child.props.label !== activeTab) {
              return
            }
            return child.props.children
          })}
        </div>
      </div>
    </>
  )
}
